import React from 'react';
import styles from "./webUser.scss";
import OutageAlertContainer from "../OutageAlerts/outageAlertContainer";
import EmergencyAlertContainer from "../EmergencyAlerts/emergencyAlertContainer";
import { getLocalizedStrings } from "../../centralizedLocalizedString";
import { getLocalizedStringstwo } from "../../centralizedLocalizedStringtwo";

const WebUser = (props) => {
    let strings = getLocalizedStringstwo("MyAccountUser");
    let accountDetails=props.accountDetails;
    let preferenceDetails=props.preferenceDetails;
    return(
        <div>
        <div className={styles.CardCointainer}>
        <div className={styles.conHeading}>{strings.OutageAlertsLabel}   </div>
        <div>
            <EmergencyAlertContainer
                       accountData={accountDetails} dropDownData={props.dropDownData}
                       preferenceData={preferenceDetails[0].emrg} updateDropDownData={props.updateDropDownData}
                       selectedAccount={!_.isEmpty(props.cpcData.contractAccountResults) ?  !_.isEmpty(props.cpcData.contractAccountResults[0].contractResults) ? props.cpcData.contractAccountResults[0].contractResults[0] : {} : {}}
                       formattedDataForEmrg={props.formattedDataForEmrg}
                       refreshPage={props.refreshPage} removePreference={props.removePreference}
                       mainBpNumber={props.cpcData.bpNumber} staticContent={props.staticContent.ea}
                      />
        </div>
        <div>
            <OutageAlertContainer
                       accountData={accountDetails} dropDownData={props.dropDownData}
                       preferenceData={preferenceDetails[0].outg} updateDropDownData={props.updateDropDownData}
                       selectedAccount={!_.isEmpty(props.cpcData.contractAccountResults) ?  !_.isEmpty(props.cpcData.contractAccountResults[0].contractResults) ? props.cpcData.contractAccountResults[0].contractResults[0] : {} : {}}
                       formattedDataForOutg={props.formattedDataForOutg}
                       refreshPage={props.refreshPage} removePreference={props.removePreference}
                       mainBpNumber={props.cpcData.bpNumber} staticContent={props.staticContent.rm}
                      />
        </div>
      </div>
        </div>   
    );
};

export default WebUser;